import debug from "debug";
import plugin from '../../lib/plugin';
export const MODULE_NAME = 'app.core/modules/video-blocks';
export const ELEMENT_SELECTOR = '[data-video-modal-trigger]';

const log = debug(MODULE_NAME);


export function exec () {
    $(document).ready(() => {
        const elements = $(ELEMENT_SELECTOR).toArray();
        if (!elements || !elements.length) {return; }
        const { VideoBlockComponent} = require('./component');
        plugin('videoBlock', VideoBlockComponent);
        $(elements).videoBlock();
    });
}


// WEBPACK FOOTER //
// ./project/client/src/core/modules/video-blocks/index.js